module.exports = __webpack_public_path__ + "static/media/stress-large@3x.cca49e7f.png";